<!-- eslint-disable max-len -->
<template>
    <div>
      <div class="modal" id="confirm-clear-cart" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <p>{{ translations.areYouSureEmptyShoppingCart }}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="clearCart()">
                {{ translations.yes }}</button>
              <button type="button" class="btn btn-primary" @click="closeConfirmationModal()">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" id="save-shopping-cart" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="first-name"> {{ translations.forms.labels.name }}<span class="required">*</span> </label>
                    <input
                      type="text"
                      placeholder="Naziv"
                      id="first-name"
                      required="required"
                      class="form-control mw-100"
                      v-model="shoppingCartTitle"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="shopping-cart-description">
                      {{ translations.description }} <span class="required">*</span>
                    </label>
                    <textarea
                      type="text"
                      id="shopping-cart-description"
                      :placeholder="translations.description"
                      required="required"
                      class="form-control"
                      v-model="shoppingCartDescription"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary mr-0" @click="saveShoppingCart()">
                {{ translations.save }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" v-if="cart && cart.cartItems">
          <div class="col-lg-8">
            <div class="cart-table-container">
              <table class="table table-cart">
                <thead>
                  <tr>
                    <th class="product-col">{{ translations.article }}</th>
                    <th>{{ translations.forms.labels.code }}</th>
                    <th class="qty-col">{{ translations.quantity }}</th>
                    <th v-if="canViewPrices" class="price-col">{{ translations.vpc }}</th>
                    <th v-if="canViewPrices" class="price-col">{{ translations.discount }}</th>
                    <th v-if="canViewPrices" class="qty-col">{{ translations.tax2 }}</th>
                    <th v-if="canViewPrices" class="qty-col">{{ translations.totalWithVat }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="product-row responsive-table" :key="item.id" v-for="item in cart.cartItems">
                    <td class="product-col">
                      <figure class="product-image-container">
                        <router-link
                          class="product-image"
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.article) },
                          }"
                        >
                          <Photo
                            :src="`${baseUrl}${item.highlightedImageUrl}`"
                            v-if="item.highlightedImageUrl"
                          />
                          <Photo src="assets/images/no-image.jpg" v-else />
                        </router-link>
                        <a
                          class="btn-remove icon-cancel"
                          title="Ukloni proizvod"
                          @click.stop.prevent="removeCartItem(item.id)"
                        ></a>
                      </figure>
                      <div class="title-attributes">
                        <h2 class="product-title">
                          <router-link
                            :to="{
                              name: 'Article',
                              params: { id: item.articleId, slug: slugify(item.article) },
                            }"
                          >
                            {{ item.article }}
                          </router-link>
                        </h2>
                        <div v-if="item.variation != null">
                        <p
                          class="cart-attribut-title"
                          v-for="attribute in item.variation.variationCombinations"
                          :key="attribute.attributeId"
                        >
                            <span v-if="attributes[attribute.attributeId]">
                              {{ attributes[attribute.attributeId].title }}:
                            </span>
                            <span
                              class="cart-attribut-value"
                              v-if="attributes[attribute.attributeId] && attributes[attribute.attributeId].attributeStyle === 1"
                            >
                              <span
                                class="attribute-style-1"
                                :style="{
                                  background: getAttributeComibation({
                                    attributeId: attribute.attributeId,
                                    attributeValueId: attribute.attributeValueId,
                                  }),
                                }"
                              ></span>
                            </span>
                            <span class="cart-attribut-value" v-else>
                              {{
                                getAttributeComibation({
                                  attributeId: attribute.attributeId,
                                  attributeValueId: attribute.attributeValueId,
                                })
                              }}
                            </span>
                          </p>
                        </div>
                        <p
                          class="cart-attribut-title"
                          v-for="attribute in item.attributteCombinations"
                          :key="attribute.attributeId"
                        >
                          <span v-if="attributes[attribute.attributeId]">
                            {{ attributes[attribute.attributeId].title }}:
                          </span>
                          <span
                            class="cart-attribut-value"
                            v-if="attributes[attribute.attributeId] && attributes[attribute.attributeId].attributeStyle === 1"
                          >
                            <span
                              class="attribute-style-1"
                              :style="{
                                background: getAttributeComibation({
                                  attributeId: attribute.attributeId,
                                  attributeValueId: attribute.attributeValueId,
                                }),
                              }"
                            ></span>
                          </span>

                          <span class="cart-attribut-value" v-else>
                            {{
                              getAttributeComibation({
                                attributeId: attribute.attributeId,
                                attributeValueId: attribute.attributeValueId,
                              })
                            }}
                          </span>
                        </p>
                      </div>
                    </td>
                    <td>
                      {{ item.variation?.article?.code ?? item.code }}
                    </td>
                    <td>
                      <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                        <input
                          class="vertical-quantity form-control"
                          type="number"
                          @blur="onBlurHandle(item)"
                          v-model.number="item.quantity"
                        />
                        <span class="input-group-btn-vertical">
                          <button
                            class="btn btn-outline bootstrap-touchspin-up icon-up-dir"
                            type="button"
                            @click="changeQuantity(item, item.orderQuantityRatio)"
                          />
                          <button
                            class="btn btn-outline bootstrap-touchspin-down icon-down-dir"
                            type="button"
                            @click="changeQuantity(item, -item.orderQuantityRatio)"
                          />
                        </span>
                      </div>
                    </td>
                    <td v-if="canViewPrices">{{ item.variation?.article?.price?.toFixed(2)?.replace('.', ',') ?? item.articleVPC.toFixed(2).replace('.', ',') }}</td>
                    <td v-if="canViewPrices">{{ item.discount > 0 ? item.discount.toFixed(2).replace('.', ',') + '%' : '-'}}</td>
                    <td v-if="canViewPrices">{{ item.totalAmountVat.toFixed(2).replace('.', ',') }}</td>
                    <td v-if="canViewPrices">{{ item.totalAmount.toFixed(2).replace('.', ',') }}</td>
                  </tr>
                  <!-- mobilni prikaz -->
                <tr class="d-flex mb-1 min-vw-100 d-md-none"
                :key="item.id" v-for="item in cart.cartItems">
                  <div class="cart-item w-100">
                  <div class="cart-item-image">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: {
                            id: item.articleId,
                            slug: slugify( item.article ),
                          },
                        }"
                      >
                        <Photo
                          :src="`${baseUrl}${item.highlightedImageUrl}`"
                          v-if="item.highlightedImageUrl"
                        />
                        <Photo src="assets/images/no-image.jpg" v-else />
                      </router-link>
                      <a
                        class="btn-remove icon-cancel "
                        title="Ukloni proizvod"
                        @click.stop.prevent="removeCartItem(item.id)"
                      ></a>
                    </figure>
                  </div>
                  <div class="cart-item-details">
                    <div class="cart-item-title">
                      <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId || item.id, slug: slugify(item.article) },
                          }"
                        >
                          {{ item.article  }}
                        </router-link>
                      <span class="more-info"></span>
                    </div>
                    <div class="cart-item-code">
                      {{ translations.forms.labels.code }}: {{ item.code }}</div>
                    <div class="cart-item-price" v-if="canViewPrices">{{ item.totalAmount.toFixed(2).replace('.', ',')}} KM</div>
                  </div>
                  <div class="cart-item-quantity">
                    <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                      <input
                        class="vertical-quantity form-control"
                        type="number"
                        @blur="onBlurHandle(item)"
                        v-model.number="item.quantity"
                      />
                      <span class="input-group-btn-vertical">
                        <button
                          class="btn btn-outline bootstrap-touchspin-up icon-up-dir"
                          type="button"
                          @click="changeQuantity(item, item.orderQuantityRatio)"
                        />
                        <button
                          class="btn btn-outline bootstrap-touchspin-down icon-down-dir"
                          type="button"
                          @click="changeQuantity(item, -item.orderQuantityRatio)"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                </tr>
                <!-- mobilni prikaz kraj -->
                </tbody>
              </table>
            </div>
            <!-- End .cart-table-container -->
            <div class="cart-actions-outer">
              <div class="cart-actions-layout">
                <button
                  class="btn btn-danger cart-action-button cart-action-button-danger"
                  @click.stop.prevent="confirmClearCart()"
                >
                  {{ translations.clearShoppingCart }}
                </button>
                <div class="cart-actions-desktop-only">
                  <button
                    class="btn btn-outline-secondary cart-action-button"
                    @click.stop.prevent="showSaveShoppingCartModal()"
                  >
                    {{ translations.saveShoppingCart }}
                  </button>
                </div>
                <div class="cart-actions-grid">
                  <button
                    class="btn btn-outline-secondary cart-action-button btn-update-cart"
                    @click.stop.prevent="updateCart()"
                  >
                    {{ translations.updateShoppingCart }}
                  </button>
                  <router-link
                    :to="{ name: 'Home' }"
                    exact
                    class="btn btn-outline-secondary cart-action-button"
                  >
                    {{ translations.continueShopping }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="cart-discount d-none d-md-block">
              <h4>{{ translations.discountCode }}</h4>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="translations.discountCode"
                  v-model="discountCode"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary discount-apply-button" type="button" @click="applyDiscountCode()">{{ translations.apply }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- End .col-lg-8 -->
            <div class="col-lg-4 position-sticky">
              <div class="cart-discount d-md-none mb-3">
                <h4>{{ translations.discountCode }}</h4>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="translations.discountCode"
                    v-model="discountCode"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-primary discount-apply-button" type="button" @click="applyDiscountCode()">{{ translations.apply }}</button>
                  </div>
                </div>
              </div>
              <div class="cart-summary mb-1" style="top: 100px">
              <h3>{{ translations.shoppingCart }}</h3>
              <!-- End #total-estimate-section -->
              <table  v-if="canViewPrices" class="table table-totals" style="margin-bottom: 0;">
                <tbody>
                  <tr v-if="(cart && cart.cartItems) || cart && cart.length">
                    <td>{{ translations.orderTotalAmountWithoutVat }}</td>
                    <td>{{ ((cart.totalAmountWithoutVat != null ? (cart.totalAmountWithoutVat) : 0)).toFixed(2)
                      }} KM
                    </td>
                  </tr>
                  <tr v-if="(cart && cart.cartItems) || cart && cart.length">
                    <td>+ {{ translations.tax }}:</td>
                    <td>{{ cart.totalAmountVat?.toFixed(2) }} KM</td>
                  </tr>
                </tbody>
                <tfoot v-if="canViewPrices && ((cart && cart.cartItems) || cart && cart.length) && !cart.giftCard &&
                    (!cart.promoCode || (cart.promoCode && cart.promoCode.discountApplianceType !== 1))">
                  <tr>
                    <td>{{ translations.totalWithVat }}</td>
                    <td>
                      {{
                        cart.totalAmount?.toFixed(2)
                      }} KM
                    </td>
                  </tr>
                </tfoot>
              </table>
              <table class="table table-totals" v-if="cart.giftCard">
                  <tbody>
                    <tr v-if="cart && cart.cartItems">
                      <td>{{ translations.totalWithVat }}:</td>
                      <td>{{ (cart.totalAmountWithoutVat + cart.totalAmountVat).toFixed(2) }} KM</td>
                    </tr>
                    <tr v-if="cart.giftCard">
                      <td>- {{ translations.giftCard }}</td>
                      <td>-{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="canViewPrices && cart && cart.cartItems">
                    <tr>
                      <td>{{ translations.totalWithVat }}</td>
                      <td v-if="cart && cart.cartItems">{{cart.totalAmount.toFixed(2) }} KM</td>
                    </tr>
                  </tfoot>
                </table>
                <table class="table table-totals" v-if="cart.promoCode
                && cart.promoCode.discountApplianceType === 1 ">
                  <tbody>
                    <tr v-if="cart && cart.cartItems">
                      <td>{{ translations.totalWithVat }}:</td>
                      <td>{{ (cart.totalAmountWithoutVat + cart.totalAmountVat).toFixed(2) }} KM</td>
                    </tr>
                    <tr v-if="cart.promoCode
                      && cart.promoCode.discountApplianceType === 1">
                      <td>- {{ translations.promoCode }}</td>
                      <td>-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="cart && cart.cartItems">
                    <tr>
                      <td>{{ translations.totalWithVat }}</td>
                      <td v-if="canViewPrices && cart && cart.cartItems">{{cart.totalAmount.toFixed(2) }} KM</td>
                    </tr>
                  </tfoot>
                </table>
              <div class="checkout-methods">
                <router-link :to="{ name: 'Checkout' }" class="btn btn-block btn-sm btn-primary">
                  {{ translations.goToCheckout }}
                </router-link>
              </div>
              <!-- End .checkout-methods -->
            </div>
              <!-- End .cart-summary -->
              <div v-if="cart.promoCode
                    && cart.promoCode.discountApplianceType !== 1"
                    class="d-flex justify-content-center align-items-center">
                    <span>
                      {{ translations.promoCodeDiscount }} {{ cart.promoDiscount.toFixed(2) }} KM
                    </span>
                </div>
              <!-- End .col-lg-4 -->
            </div>
          </div>
        <div v-else>
          <div class="alert alert-info">{{ translations.yourCartIsEmpty }}</div>
        </div>
        <!-- End .row -->
      </div>
      <!-- End .container -->
    </div>
  </template>

<script>
import Vue from 'vue';
import { debounce } from 'lodash';
import api from '@/services/api';
import config from '@/config';
import slugify from '@/filters/slugify';
import { translations } from '@/mixins';

import Photo from '@/components/shared/Image.vue';

export default {
  name: 'ShoppingCart',
  mixins: [translations],
  components: { Photo },
  data() {
    return {
      shoppingCartDescription: '',
      shoppingCartTitle: '',
      discountCode: '',
    };
  },
  computed: {
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    cartTableColspan() {
      return this.canViewPrices ? 7 : 3;
    },
    baseUrl() {
      return config.baseUrl;
    },
    attributes() {
      return this.$store.getters.getAttributesAsObj;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getAttributes', { retrieveAll: true });
    this.$store.dispatch('getShoppingCart');
  },
  methods: {
    slugify,
    showSaveShoppingCartModal() {
      $('#save-shopping-cart').modal('show');
    },
    clearCart() {
      api
        .clearCart(this.cart.id)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        })
        .finally(() => {
          this.closeConfirmationModal();
          this.$store.dispatch('getShoppingCart');
          this.$router.push({ name: 'Home' });
        });
    },
    updateCart() {
      api
        .updateCart(this.cart.cartItems)
        .then((response) => {
          this.$toast.info(response?.data?.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
        })
        .finally(() => {
          this.$store.dispatch('getShoppingCart');
        });
    },
    saveShoppingCart() {
      const { shoppingCartTitle, shoppingCartDescription } = this;
      if (!shoppingCartTitle || !shoppingCartDescription) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      api
        .saveShoppingCart({
          title: shoppingCartTitle,
          description: shoppingCartDescription,
          shoppingCartId: this.cart.id,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
        })
        .finally(() => {
          $('#save-shopping-cart').modal('hide');
        });
    },
    removeCartItem(cartItemId) {
      api.removeCartItem(cartItemId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
      });
    },
    getAttributeComibation({ attributeId, attributeValueId }) {
      const value = this.attributes[attributeId]?.attributeProperties.find(
        (i) => i.id === attributeValueId,
      );
      return value?.label;
    },
    changeQuantity(item, quantity) {
      let updatedQuantity = quantity;
      if (quantity == null || quantity === 0) {
        updatedQuantity = 1;
      }
      let value = item.quantity + updatedQuantity;
      if (value < 1) value = 1;
      Vue.set(item, 'quantity', value);

      const handleUpdate = debounce(() => {
        this.updateCart();
      }, 1000);

      handleUpdate();
    },
    onBlurHandle(item) {
      const quantity = item.minOrderQuantity || 1;
      // orderQuantityRatio
      if (item.orderQuantityRatio != null && item.orderQuantityRatio > 1) {
        const numOfDecimals = item.orderQuantityRatio.toString().split('.');
        const roundTo = numOfDecimals.length > 1 ? numOfDecimals[1].length : 0;
        const num = parseFloat(item.quantity.toFixed(roundTo), 10);
        let ratio = parseFloat((num % item.orderQuantityRatio).toFixed(roundTo), 10);

        if (ratio < item.minOrderQuantity) {
          if (num > item.minOrderQuantity) {
            ratio = parseFloat(((num - item.minOrderQuantity) % item.orderQuantityRatio)
              .toFixed(roundTo), 10);
          } else {
            ratio = parseFloat(((item.minOrderQuantity - num) % item.orderQuantityRatio)
              .toFixed(roundTo), 10);
          }
        }

        if (!Number.isInteger(item.orderQuantityRatio)) {
          Vue.set(item, 'quantity', parseFloat(item.quantity, 10));
        } else {
          Vue.set(item, 'quantity', parseFloat((item.quantity - ratio).toFixed(roundTo), 10));
        }
      }
      if (item.quantity < 1) Vue.set(item, 'quantity', quantity);
      this.updateCart();
    },
    confirmClearCart() {
      $('#confirm-clear-cart').modal('show');
    },
    closeConfirmationModal() {
      $('#confirm-clear-cart').modal('hide');
    },
    applyDiscountCode() {
      if (!this.discountCode) return;
      api
        .applyDiscountCode(this.cart.id, this.discountCode)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getShoppingCart');
          this.discountCode = '';
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        });
    },
  },
};
</script>
<style lang="scss" scoped>

// mobilni prikaz

.cart-item {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  font-family: Arial, sans-serif;
}

.cart-item-image {
  width: 80px;
  height: auto;
  border-radius: 4px;
}

.cart-item-details {
  flex: 1;
  margin-left: 10px;
}

.cart-item-title {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.cart-item-title .more-info {
  margin-left: 5px;
  font-size: 14px;
  font-weight: normal;
  color: #888;
}

.cart-item-description {
  font-size: 14px;
  color: #555;
}

.cart-item-code {
  font-size: 12px;
  color: #888;
}

.cart-item-price {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.cart-item-quantity {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}

// mobilni prikaz kraj

.attribute-style-1 {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-bottom: -5px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

label {
  cursor: pointer;
}

.btn-remove {
  cursor: pointer;

  &:hover {
    color: #1e84bc !important;
  }
}

.table.table-cart .product-title {
  margin-bottom: 5px;
}

.cart-attribut-title {
  font-size: 1.3rem;
}

.cart-attribut-value {
  margin-left: 3px;
}

#confirm-clear-cart .modal-dialog {
  max-width: 500px;
}

.cart-discount {
  margin-top: 1.5rem;

  h4 {
    font-size: 1.8rem;
    font-weight: 500;
    margin-bottom: 0.8rem;
    color: #767F84;
  }

  .input-group {
    max-width: 380px;
  }
}

.discount-apply-button {
  text-transform: none;
}

.product-image-container {
  max-width: 130px;
}

.product-title {
  font-size: 18px;
}

.cart-actions-outer {
  border-top: 1px solid #dee2e6;
  padding: 1.5rem 0 1rem;
  margin-bottom: 0.5rem;
 padding-left: 15%;
}

.cart-actions-layout {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.cart-actions-grid {
  display: grid;
  gap: 1.2rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cart-actions-desktop-only {
  display: flex;
  justify-content: flex-start;
}

.cart-action-button {
  text-transform: none;
  font-weight: 400;
  font-size: 1.15rem;
  letter-spacing: normal;
}

.cart-action-button.btn-outline-secondary,
.cart-action-button-danger {
  font-weight: 400;
  font-size: 1.15rem;
  letter-spacing: normal;
}

@media (min-width: 768px) {
  .cart-actions-outer {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    border-top: 1px solid #dee2e6;
    padding-top: 1.5rem;
  }

  .cart-actions-layout {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.8rem;
    flex-wrap: nowrap;
  }

  .cart-action-button-danger {
    width: auto;
    flex-shrink: 0;
    margin-left: -22%;
    margin-right: 22%;
  }

  .cart-actions-desktop-only {
    width: auto;
    justify-content: flex-start;
  }

  .cart-actions-grid {
    display: flex;
    width: auto;
    gap: 0.8rem;
  }

  .cart-action-button {
    width: auto;
    min-height: 4rem;
    height: 4rem;
    padding: 0 2.2rem;
    font-size: 1.7rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .cart-action-button.btn-outline-secondary {
    font-size: 1.7rem;
  }

  .cart-action-button-danger {
    font-size: 1.7rem;
  }
}

.cart-action-button.btn-outline-secondary {
  background: #f8f7f7;
  border: 1px solid #d6dbe1;
  color: #929598;
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: normal;
}

.cart-action-button.btn-outline-secondary:hover,
.cart-action-button.btn-outline-secondary:focus {
  background: #1E84BC;
  border-color: #c7d0d9;
  color: #ebeef1;
}

.cart-action-button-danger {
  background: #de3846;
  border-color: #de3846;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 300;
  letter-spacing: normal;
}

.cart-action-button-danger:hover,
.cart-action-button-danger:focus {
  background: #c92f3c;
  border-color: #c92f3c;
  color: #fff;
}

@media only screen and (max-width: 767px) {
  .responsive-table {
    display: none !important;
  }

  .cart-actions-outer {
    padding-top: 10px;
  }

  .cart-actions-desktop-only {
    display: none;
  }

  .cart-actions-layout {
    gap: 1rem;
    margin-left: -18%;
    margin-right: 0;
    width: 120%;
  }

  .cart-actions-grid {
    gap: 0.8rem;
  }

  .cart-action-button {
    height: 4.6rem;
    min-height: 4.6rem;
    padding: 0.8rem 1.2rem;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .cart-action-button.btn-outline-secondary {
    font-size: 1.25rem;
    letter-spacing: 0.07em;
  }

  .cart-action-button-danger {
    font-size: 1.25rem;
    letter-spacing: 0.05em;
  }
}
</style>
